module.exports = __webpack_public_path__ + "static/posts-3-ebc03dc10b8f2a3896121de84d569416.jpg";